<template>
  <div class="login">
    <div class="form">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginFormRules"
      >
        <el-form-item
          prop="name.val"
          label="用户名"
        >
          <el-input
            v-model="loginForm.name.val"
            :placeholder="loginForm.name.placeholder"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item
          prop="psw.val"
          label="密码"
        >
          <el-input
            v-model="loginForm.psw.val"
            :placeholder="loginForm.psw.placeholder"
            show-password
            @keyup.enter.native="submit"
          />
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        @click="submit"
      >
        登录
      </el-button>
    </div>
  </div>
</template>
<script>
import axClient from '@/services';
import md5 from 'js-md5';
import { menuConfig } from '@/config';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        name: {
          val: '',
          placeholder: '请输入您的用户名',
        },
        psw: {
          val: '',
          placeholder: '请输入您的密码',
        },
        checked: false,
      },
      loginFormRules: {
        'name.val': [
          { required: true, message: '请输入您的用户名', trigger: 'blur' },
        ],
        'psw.val': [
          { required: true, message: '请输入您的密码', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 登录提交
    submit() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.login.login({
            loginName: this.loginForm.name.val,
            password: md5(this.loginForm.psw.val),
          });
          if (data) {
            const permissionList = this.getPermissionList(data.permissionIds ? data.permissionIds : []);
            console.log(permissionList);
            // 找到可以跳转到那一页
            if (permissionList.length === 0) {
              this.$message.error('该账户未配置权限,请配置菜单权限后使用');
            } else {
              this.$message.success('登录成功');
              localStorage.setItem('token', data.token);
              localStorage.setItem('user', JSON.stringify(data));
              this.$store.dispatch('user', data);
              axClient.client.refeshToken();
              this.$router.push({
                path: permissionList[0].path,
                query: {
                  reload: true,
                },
              });
            }
          } else {
            this.$message.error(data.reason);
          }
        } else {
          this.$message.error('登录失败');
        }
      });
    },
    // 计算有权限的菜单
    getPermissionList(arr) {
      let menuList = [];
      menuConfig.forEach((menu) => {
        menuList = [...menuList, ...menu.children.filter((child) => arr.includes(child.id))];
      });
      return menuList;
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/images/login/bg.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    background: rgba($--base-color-black, 0.8);
  }
  .form {
    display: flex;
    flex-direction: column;
    margin-top: 300px;
    padding: 32px 18px;
    text-align: center;
    box-sizing: border-box;
    z-index: 1;
    .el-form-item {
      margin-bottom: 0;
    }
    ::v-deep label {
      font-weight: 600;
      font-size: 15px;
      line-height: 21px;
      margin-top: 16px;
      margin-bottom: 8px;
      color: $--base-color-grey-light-3;
      &::before {
        display: none;
      }
    }
    ::v-deep .el-input {
      font-size: 16px;
      .el-input__inner {
        padding-left: 10px;
        height: 52px;
      }
    }
    // ::v-deep .el-form-item__content{
    //   display: block;
    // }
    ::v-deep input {
      width: 295px;
      border-radius: 0;
      font-size: 14px;
      color: rgba($--base-color-black, 1);
      border: 1px solid rgba($--base-color-main, 1);
    }
    button {
      height: 52px;
      margin-top: 36px;
    }
  }
}
</style>
